module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics analytics-transactions"
  }, [_c('row', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Transaction.generalStatus'),
      "name": "first"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.trxAmount')) + " (" + _vm._s(_vm.$store.state.theme.companyInfo.currency) + ")")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.first.statusRadio),
      callback: function($$v) {
        _vm.first.statusRadio = $$v
      },
      expression: "first.statusRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.first.statusOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetStatusOp('week', 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.first.statusOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetStatusOp('month', 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.first.statusOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetStatusOp('year', 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "status",
    attrs: {
      "options": _vm.first.statusOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Transaction.byChannel'),
      "name": "second"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.transactionByChannel')) + " (" + _vm._s(_vm.$store.state.theme.companyInfo.currency) + ")")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.second.channelRadio),
      callback: function($$v) {
        _vm.second.channelRadio = $$v
      },
      expression: "second.channelRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.second.channelOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetChannelOp('week', 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.second.channelOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetChannelOp('month', 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.second.channelOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetChannelOp('year', 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "byChannel",
    staticClass: "sl-any-bar",
    attrs: {
      "options": _vm.second.channelOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Transaction.percentage'),
      "name": "third"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-2"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.channelPercentage')))]), _vm._v(" "), _c('chart', {
    ref: "percentageChannel",
    attrs: {
      "options": _vm.third.channelOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sl-col-2"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.statusPercentage')))]), _vm._v(" "), _c('chart', {
    ref: "percentageStatus",
    attrs: {
      "options": _vm.third.statusOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-537249de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/analytics/transactions.vue
// module id = 1109
// module chunks = 1